import { convertNewlinesToBr } from '@utils/utils';
import { Typography } from 'antd';
import React from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { strings } from '../../../constants/strings';

const { Paragraph } = Typography;

const DescriptionDisplay = ({ data, expanded, setExpanded, isRichEditor = false, onReadMoreClick = null }) => {
  const descriptionTextDisplayLength = 200;
  const fullText = data?.description;
  const truncatedText =
    fullText?.length > descriptionTextDisplayLength ? fullText?.slice(0, descriptionTextDisplayLength) : fullText;

  const renderContent = () => {
    const textToDisplay = expanded
      ? fullText
      : `${truncatedText}${fullText?.length > descriptionTextDisplayLength ? '...' : ''}`;

    if (isRichEditor) {
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: textToDisplay,
          }}
        />
      );
    }
    return convertNewlinesToBr(textToDisplay).map(({ key, content }) => (
      <span key={key}>
        {content}
        <br />
      </span>
    ));
  };

  const handleReadMoreClick = () => {
    if (onReadMoreClick) {
      onReadMoreClick(fullText);
    } else {
      setExpanded(true);
    }
  };

  return (
    <Paragraph style={{ display: 'inline', margin: 0 }}>
      {!!fullText && renderContent()}
      {!expanded && fullText?.length > descriptionTextDisplayLength && (
        <span
          className="fw-600 cursor-pointer"
          style={{
            color: 'var(--ant-color-primary)',
            display: 'inline-flex',
            alignItems: 'center',
          }}
          onClick={handleReadMoreClick}
        >
          {strings.read_more} <MdKeyboardArrowDown />
        </span>
      )}
      {expanded && (
        <p
          className="fw-600 cursor-pointer"
          style={{
            color: 'var(--ant-color-primary)',
            display: 'inline-flex',
            alignItems: 'center',
          }}
          onClick={() => setExpanded(false)}
        >
          {strings.read_less} <MdKeyboardArrowUp />
        </p>
      )}
    </Paragraph>
  );
};

export default DescriptionDisplay;
